import React, {Component} from "react";
import CommToolContext from "../common/comm_tool_context";
import {Grid, Row, Col} from "react-flexbox-grid";
import ClosedTabs from "./closed_tabs";
import {getProject} from '../../api';

class ClosedProject extends Component {

    constructor(props) {
        super(props);

        this.state = {
            projectId: props.match.params.projectId
        }
    }

    async componentDidMount() {
        const project = await getProject(this.state.projectId);

        this.setState({
            project
        })
    }

    render() {
        const {project} = this.state;

        return (
            <CommToolContext.Consumer>
                {context => (
                    <React.Fragment>
                        <Grid fluid>
                            <Row>
                                <Col xs>
                                    {project && <ClosedTabs project={project} context={context}/>}
                                </Col>
                            </Row>
                        </Grid>
                    </React.Fragment>
                )}
            </CommToolContext.Consumer>
        );
    }
}

ClosedProject.contextType = CommToolContext;
export default ClosedProject;
